// icons.jsx — minimal stroke icon set (Lucide-inspired, original)
import React from 'react';

const Ic = {};
// JSDoc-typed so TS callers importing this .jsx module can pass standard SVG
// props (style, aria-hidden, etc.) through to the underlying <svg> — allowJs
// infers the exported member types from here even with checkJs off.
const make = (path) =>
  /** @param {React.SVGProps<SVGSVGElement>} [props] */
  (props = {}) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {path}
    </svg>
  );

Ic.dashboard = make(
  <>
    <rect x="3" y="3" width="7" height="9" rx="1.5" />
    <rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" />
    <rect x="3" y="16" width="7" height="5" rx="1.5" />
  </>
);
Ic.catalog = make(
  <>
    <path d="M4 5h12a2 2 0 012 2v13H6a2 2 0 01-2-2V5z" />
    <path d="M4 5a2 2 0 012-2h12" />
    <path d="M8 8h8M8 12h6" />
  </>
);
Ic.selector = make(
  <>
    <circle cx="12" cy="12" r="8" />
    <path d="M12 4v3M12 17v3M4 12h3M17 12h3" />
    <circle cx="12" cy="12" r="2.5" />
  </>
);
Ic.commercial = make(
  <>
    <path d="M3 7h18l-2 12H5L3 7z" />
    <path d="M8 7V5a4 4 0 018 0v2" />
  </>
);
Ic.finance = make(
  <>
    <rect x="3" y="6" width="18" height="13" rx="2" />
    <path d="M3 10h18" />
    <path d="M7 15h4" />
  </>
);
Ic.contract = make(
  <>
    <path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9z" />
    <path d="M14 3v6h6" />
    <path d="M8 13h8M8 17h5" />
  </>
);
Ic.materials = make(
  <>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="9" cy="11" r="2" />
    <path d="M21 17l-5-5-7 7" />
  </>
);
Ic.service = make(
  <>
    <path d="M14.7 6.3a1 1 0 010 1.4l-9 9a1 1 0 01-1.4 0l-1-1a1 1 0 010-1.4l9-9a1 1 0 011.4 0l1 1z" />
    <path d="M16 4l4 4M19 11l2 2-3 3-2-2" />
  </>
);
Ic.news = make(
  <>
    <path d="M4 4h12v16H6a2 2 0 01-2-2V4z" />
    <path d="M16 8h3a1 1 0 011 1v9a2 2 0 01-2 2" />
    <path d="M7 8h6M7 12h6M7 16h4" />
  </>
);
Ic.search = make(
  <>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3" />
  </>
);
Ic.bell = make(
  <>
    <path d="M6 8a6 6 0 0112 0c0 7 3 8 3 8H3s3-1 3-8z" />
    <path d="M10 21a2 2 0 004 0" />
  </>
);
Ic.help = make(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 4" />
    <circle cx="12" cy="17" r=".6" fill="currentColor" />
  </>
);
Ic.chev = make(<path d="M9 6l6 6-6 6" />);
Ic.chevDown = make(<path d="M6 9l6 6 6-6" />);
Ic.plus = make(
  <>
    <path d="M12 5v14M5 12h14" />
  </>
);
Ic.download = make(
  <>
    <path d="M12 4v12M6 10l6 6 6-6" />
    <path d="M4 20h16" />
  </>
);
Ic.upload = make(
  <>
    <path d="M12 20V8M6 14l6-6 6 6" />
    <path d="M4 4h16" />
  </>
);
Ic.filter = make(<path d="M4 5h16l-6 8v6l-4-2v-4z" />);
Ic.grid = make(
  <>
    <rect x="4" y="4" width="7" height="7" rx="1" />
    <rect x="13" y="4" width="7" height="7" rx="1" />
    <rect x="4" y="13" width="7" height="7" rx="1" />
    <rect x="13" y="13" width="7" height="7" rx="1" />
  </>
);
Ic.list = make(
  <>
    <path d="M4 6h16M4 12h16M4 18h16" />
  </>
);
Ic.arrowUp = make(<path d="M12 19V5M5 12l7-7 7 7" />);
Ic.arrowDown = make(<path d="M12 5v14M5 12l7 7 7-7" />);
Ic.check = make(<path d="M5 12l5 5L20 7" />);
Ic.x = make(<path d="M6 6l12 12M18 6L6 18" />);
Ic.eye = make(
  <>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </>
);
Ic.eyeOff = make(
  <>
    <path d="M3 3l18 18" />
    <path d="M10.6 5.1A11 11 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-2.9 3.8" />
    <path d="M6.6 6.6C3.6 8.7 2 12 2 12s3.5 7 10 7c1.6 0 3-.4 4.3-1" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </>
);
Ic.dl = Ic.download;
Ic.print = make(
  <>
    <path d="M6 9V3h12v6" />
    <rect x="4" y="9" width="16" height="8" rx="1" />
    <path d="M7 17v4h10v-4" />
  </>
);
Ic.copy = make(
  <>
    <rect x="8" y="8" width="12" height="12" rx="2" />
    <path d="M16 8V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h3" />
  </>
);
Ic.send = make(<path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />);
Ic.play = make(<path d="M8 5l12 7-12 7V5z" fill="currentColor" />);
Ic.pdf = make(
  <>
    <path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9z" />
    <path d="M14 3v6h6" />
  </>
);
Ic.image = make(
  <>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="9" cy="11" r="2" />
    <path d="M21 17l-5-5-7 7" />
  </>
);
Ic.zip = make(
  <>
    <path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9z" />
    <path d="M10 4v3M10 9v2M10 13v2M10 17v2" />
  </>
);
Ic.brand = make(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 3a9 9 0 010 18M3 12h18" />
  </>
);
Ic.world = make(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a13 13 0 010 18M12 3a13 13 0 000 18" />
  </>
);
Ic.calendar = make(
  <>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 9h18M8 3v4M16 3v4" />
  </>
);
Ic.user = make(
  <>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0116 0" />
  </>
);
Ic.factory = make(
  <>
    <path d="M3 21V10l5 3V10l5 3V8l8 5v8H3z" />
    <path d="M8 21v-4M13 21v-4M18 21v-4" />
  </>
);
Ic.fire = make(
  <>
    <path d="M12 3s5 4 5 9a5 5 0 01-10 0c0-2 1-3 1-3s2 1 2 3c0-3 2-5 2-9z" />
  </>
);
Ic.drop = make(
  <>
    <path d="M12 3s7 7 7 12a7 7 0 01-14 0c0-5 7-12 7-12z" />
  </>
);
Ic.bolt = make(<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />);
Ic.tools = make(
  <>
    <path d="M14 6l4 4-9 9-4 1 1-4 9-9z" />
    <path d="M16 8l4-4-2-2-4 4" />
  </>
);
Ic.book = make(
  <>
    <path d="M4 5a2 2 0 012-2h13v18H6a2 2 0 01-2-2V5z" />
    <path d="M19 16H6a2 2 0 00-2 2" />
  </>
);
Ic.cog = make(
  <>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2" />
  </>
);
Ic.menu = make(<path d="M4 6h16M4 12h16M4 18h16" />);
Ic.arrowRight = make(<path d="M5 12h14M13 5l7 7-7 7" />);
Ic.refresh = make(
  <>
    <path d="M21 12a9 9 0 11-3-6.7" />
    <path d="M21 4v5h-5" />
  </>
);
Ic.alert = make(
  <>
    <path d="M12 3l10 18H2L12 3z" />
    <path d="M12 10v5" />
    <circle cx="12" cy="18" r=".6" fill="currentColor" />
  </>
);
Ic.trend = make(
  <>
    <path d="M3 17l6-6 4 4 8-8" />
    <path d="M14 7h7v7" />
  </>
);
Ic.box = make(
  <>
    <path d="M3 7l9-4 9 4v10l-9 4-9-4V7z" />
    <path d="M3 7l9 4 9-4M12 11v10" />
  </>
);
Ic.truck = make(
  <>
    <rect x="2" y="7" width="12" height="9" rx="1" />
    <path d="M14 10h4l3 3v3h-7" />
    <circle cx="6" cy="18" r="2" />
    <circle cx="17" cy="18" r="2" />
  </>
);
Ic.handshake = make(
  <>
    <path d="M2 12l4-4 5 4-3 3-3-1-3 2z" />
    <path d="M22 12l-4-4-5 4 3 3 3-1 3 2z" />
    <path d="M11 12l1 1 2-2" />
  </>
);
Ic.chat = make(
  <>
    <path d="M21 11.5a8.5 8.5 0 0 1-12.5 7.5L3 21l2-5.5A8.5 8.5 0 1 1 21 11.5z" />
    <path d="M8 11h8M8 14.5h5" />
  </>
);

// CMMS additions (same 24x24 / stroke 1.7 idiom as the rest of the set).
// Position tree — the equipment structure ("drvo pozicija").
Ic.tree = make(
  <>
    <rect x="3" y="3" width="6" height="5" rx="1.2" />
    <rect x="15" y="10" width="6" height="5" rx="1.2" />
    <rect x="15" y="17" width="6" height="5" rx="1.2" />
    <path d="M6 8v11M6 12.5h9M6 19.5h9" />
  </>
);
// Map pin — physical locations code list ("šifarnik lokacija").
Ic.sun = make(
  <>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </>
);
Ic.moon = make(<path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11z" />);
Ic.pin = make(
  <>
    <path d="M12 21s-6-5.4-6-11a6 6 0 0 1 12 0c0 5.6-6 11-6 11z" />
    <circle cx="12" cy="10" r="2.2" />
  </>
);
// Tag — code lists (location kinds).
Ic.tag = make(
  <>
    <path d="M20.6 13.4l-7.2 7.2a1.5 1.5 0 0 1-2.1 0L3 12.3V3h9.3l8.3 8.3a1.5 1.5 0 0 1 0 2.1z" />
    <circle cx="7.5" cy="7.5" r="1.3" />
  </>
);
// Stacked layers — hierarchy / grouping (templates).
Ic.layers = make(
  <>
    <path d="M12 3l9 5-9 5-9-5 9-5z" />
    <path d="M3 12l9 5 9-5M3 16l9 5 9-5" />
  </>
);
// Warehouse — storage locations.
Ic.warehouse = make(
  <>
    <path d="M3 21V9l9-5 9 5v12" />
    <path d="M7 21v-8h10v8M7 17h10" />
  </>
);
// Door — room.
Ic.door = make(
  <>
    <path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17" />
    <path d="M3 21h18M15 12h.01" />
  </>
);

// Building — root of the position structure ("Bankom").
Ic.building = make(
  <>
    <path d="M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16" />
    <path d="M15 10h4a1 1 0 0 1 1 1v10M2 21h20" />
    <path d="M8 8h3M8 12h3M8 16h3M18 14h.01M18 18h.01" />
  </>
);
// Production line — LINE positions (conveyor with stations).
Ic.line = make(
  <>
    <path d="M2 12h20" />
    <circle cx="6" cy="12" r="2.2" />
    <circle cx="12" cy="12" r="2.2" />
    <circle cx="18" cy="12" r="2.2" />
    <path d="M6 14.2V19M12 14.2V19M18 14.2V19" />
  </>
);

// Template — a saved sub-tree layout (šablon pod-pozicija).
Ic.template = make(
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M9 9v12" />
    <path d="M13 13h4M13 17h4" />
  </>
);

// Physical-location symbols for the admin icon palette.
Ic.home = make(<><path d="M3 11l9-8 9 8M5 9v12h14V9M9 21v-7h6v7" /></>);
Ic.office = make(<><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2M10 21v-3h4v3" /></>);
Ic.garage = make(<><path d="M3 21V9l9-6 9 6v12M6 21V11h12v10M6 15h12M6 18h12M2 21h20" /></>);
Ic.hangar = make(<><path d="M2 21V11a10 8 0 0 1 20 0v10M5 21V12a7 5 0 0 1 14 0v9M5 12h14M12 12v9M2 21h20" /></>);
Ic.gate = make(<><path d="M3 21V5h3v16M18 21V5h3v16M6 9h12M6 18h12M9 9v9M12 9v9M15 9v9" /></>);
Ic.fence = make(<><path d="M4 21V5l2-2 2 2v16M16 21V5l2-2 2 2v16M8 9h8M8 16h8M2 9h2M20 9h2M2 16h2M20 16h2" /></>);
Ic.silo = make(<><path d="M5 7l7-4 7 4v11l-7 3-7-3V7zM5 7h14M5 16h14M8 20v2M16 20v2M16 7v9" /></>);
Ic.tank = make(<><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v12a8 3 0 0 0 16 0V6M4 12a8 3 0 0 0 16 0" /></>);
Ic.barrel = make(<><ellipse cx="12" cy="4" rx="6" ry="2" /><path d="M6 4C3 9 3 15 6 20a6 2 0 0 0 12 0c3-5 3-11 0-16M5 8h14M5 16h14M9 4h6" /></>);
Ic.pallet = make(<><path d="M3 13h18v4H3zM4 17v4h3v-4M17 17v4h3v-4M10 17v4h4v-4M6 13V4h12v9M6 8h12M12 4v9" /></>);
Ic.container = make(<><rect x="2" y="5" width="20" height="14" rx="1" /><path d="M6 8v8M10 8v8M14 8v8M18 8v8M4 19v2M20 19v2" /></>);
Ic.shelves = make(<><path d="M3 3v18M21 3v18M3 10h18M3 19h18" /><rect x="6" y="4" width="5" height="6" rx=".5" /><rect x="14" y="6" width="4" height="4" rx=".5" /><path d="M6 19v-6h5v6M14 19v-5h4v5" /></>);
Ic.stairs = make(<><path d="M3 21v-5h6v-6h6V4h6M3 6l14-4M5 6v6M11 4v3M21 4v17H3" /></>);
Ic.elevator = make(<><rect x="3" y="3" width="18" height="18" rx="1" /><path d="M8 21V10h8v11M12 10v11M7 7l2-2 2 2M13 5l2 2 2-2" /></>);
Ic.parking = make(<><rect x="3" y="3" width="18" height="18" rx="3" /><path d="M9 18V6h4a3.5 3.5 0 0 1 0 7H9" /></>);
Ic.car = make(<><path d="M3 17v-5l3-6h12l3 6v5H3zM3 12h18M6 6l1 6M18 6l-1 6M6 17v3M18 17v3M6 15h2M16 15h2" /></>);
Ic.forklift = make(<><path d="M3 16V9h8v7M7 9V4h5l3 12M15 4v14h7M3 16h12" /><circle cx="6" cy="19" r="2" /><circle cx="13" cy="19" r="2" /><path d="M18 6h4v8h-4z" /></>);
Ic.crane = make(<><path d="M4 22V5h4v17M2 5l5-3 15 3H2zM8 9l-4 4 4 4-4 4M18 5v8a2 2 0 1 1-2 2M2 22h8" /></>);
Ic.flask = make(<><path d="M9 3h6M10 3v7L4 20a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1l-6-10V3M7 16h10" /><circle cx="11" cy="18" r=".6" fill="currentColor" /></>);
Ic.snowflake = make(<><path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7M9 4l3 3 3-3M9 20l3-3 3 3M3 10l4-1-1-4M18 19l-1-4 4-1M6 19l1-4-4-1M21 10l-4-1 1-4" /></>);
Ic.leaf = make(<><path d="M20 3C9 2 3 7 4 14a6 6 0 0 0 10 5c5-4 6-10 6-16zM3 22L15 10M8 17v-5M8 17h5" /></>);
Ic.pine = make(<><path d="M12 2l6 7h-3l6 7h-6l5 4H4l5-4H3l6-7H6l6-7zM12 20v3" /></>);
Ic.pipe = make(<><path d="M2 4h4v8a2 2 0 0 0 2 2h10v-2h4v10h-4v-2H8a8 8 0 0 1-8-8V4M2 2h6M16 14v6" /></>);
Ic.fan = make(<><circle cx="12" cy="12" r="2" /><circle cx="12" cy="12" r="10" /><path d="M10 10C5 4 13 2 13 10M14 11c8-1 6 7-1 3M11 14c-3 7-9 1-1-2" /></>);

// Sprint 6 — layout pogona (slika sa markerima): nav icon, zoom controls, marker glyphs.
Ic.layout = make(<><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 15l5-4 4 3 3-2 6 4" /><circle cx="16" cy="9" r="2" /><path d="M16 11v3" /></>);
Ic.minus = make(<path d="M5 12h14" />);
// Bare exclamation mark (no triangle): readable at 10 px inside a layout pin.
Ic.exclaim = make(<><path d="M12 4v10" /><path d="M12 19.5v.5" /></>);
Ic.clock = make(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>);
Ic.more = make(<><circle cx="5" cy="12" r="1.2" fill="currentColor" /><circle cx="12" cy="12" r="1.2" fill="currentColor" /><circle cx="19" cy="12" r="1.2" fill="currentColor" /></>);
Ic.fit = make(<><path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5" /><rect x="9" y="9" width="6" height="6" rx="1" /></>);
Ic.pencil = make(<><path d="M4 20l4-1L19 8a2 2 0 0 0-3-3L5 16l-1 4z" /><path d="M14 6l3 3" /></>);
// Open in a new browser tab (arrow leaving a box).
Ic.external = make(<><path d="M14 4h6v6" /><path d="M20 4l-9 9" /><path d="M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5" /></>);
Ic.pinDrop = make(<><path d="M12 21s-6-5.5-6-11a6 6 0 0 1 12 0c0 5.5-6 11-6 11z" /><circle cx="12" cy="10" r="2" /></>);
// "i" in a circle — a note / explanation is available (components/TextPopover.tsx InfoPopover).
Ic.info = make(<><circle cx="12" cy="12" r="9" /><path d="M12 16v-5" /><path d="M12 8h.01" /></>);
// Route — the asset's journey through time (two stops joined by a winding path).
Ic.route = make(<><circle cx="6" cy="19" r="2.5" /><circle cx="18" cy="5" r="2.5" /><path d="M8.5 19H15a3.5 3.5 0 0 0 0-7H9a3.5 3.5 0 0 1 0-7h6.5" /></>);
// Over the whole screen / back (two diagonal arrows out, then in) — `fit` already means "zoom to fit".
Ic.maximize = make(<path d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7" />);
Ic.minimize = make(<path d="M20 4l-6 6M14 5v5h5M4 20l6-6M10 19v-5H5" />);

export default Ic;
